

let envConfig = {};
const devConfig = {
  apiUrl: "http://localhost:3305",
//   userAuthApiUrl: "http://localhost:3301",
//  userCheckApiUrl: "http://localhost:3301/v1/user/check/otherApp",
  // apiUrl: "http://192.168.55.66:3305",
  // userAuthApiUrl: "http://192.168.55.66:3301",
  // userCheckApiUrl: "http://192.168.55.66:3301/v1/user/check/otherApp",
 userAuthApiUrl: "https://testgiris.ayk.gov.tr/api/",
 userCheckApiUrl: "https://testgiris.ayk.gov.tr/api/v1/user/check/otherApp",

  activityPageUrl:"http:/localhost:3003/",
//  mainPageUrl: "http://localhost:3000/",
  mainPageUrl: "https://testgiris.ayk.gov.tr",

};
const testConfig = {
  apiUrl: "https://testbilsis.ayk.gov.tr/api/",
  mainPageUrl: "https://testgiris.ayk.gov.tr/",
  userCheckApiUrl: "https://testgiris.ayk.gov.tr/api/v1/user/check/otherApp",
  userAuthApiUrl: "https://testgiris.ayk.gov.tr/api/",
  activityPageUrl:"http://test.tamga.gov.tr/",

};
const prodConfig = {
  apiUrl: "https://bilsis.ayk.gov.tr/api/",
  mainPageUrl: "https://giris.ayk.gov.tr/",
  userCheckApiUrl: "https://giris.ayk.gov.tr/api/v1/user/check/otherApp",
  userAuthApiUrl: "https://giris.ayk.gov.tr/api/",
  activityPageUrl:"https://etkinlik.gov.tr/",

}; 
if (process.env.REACT_APP_ENV === "development") {
  envConfig = devConfig;
} else if (process.env.REACT_APP_ENV === "test") {
  envConfig = testConfig;
} else if (process.env.REACT_APP_ENV === "production") {
  envConfig = prodConfig;
}
//export  {envConfig};
////console.log("env config",envConfig);
export default {
  apiUrl: envConfig.apiUrl,
  mainPageUrl: envConfig.mainPageUrl,
  userCheckApiUrl: envConfig.userCheckApiUrl,
  userAuthApiUrl: envConfig.userAuthApiUrl,
  activityPageUrl:envConfig.activityPageUrl,

  defaultProfileImageUrl: "/uploads/images/user.jpg",


  intihalNet: {
    secretKey: "qUnLaXcBu-adCBSEmCES",
    sendUrl: "http://app.intihal.net/serviceintihal/document",
    checkUrl: "http://app.intihal.net/serviceintihal/check",
    resultUrl: "https://app.intihal.net/serviceintihal/proje",
  },

  copright: "Her hakkı saklıdır. Atatürk Kültür, Dil ve Tarih Yüksek Kurumu",
  coprightYear: "2020",

  sk: "BBSuserKey123",
  signOutUrl: "/bbs/mainPage",
  signInUrl: "/bys/mainPage",

  bitly : {
    url: "https://api-ssl.bitly.com/v4/shorten",
    guid: "Bk5rlZm619C",
    token: "5ccb9140fbe1be83dbfc752b65be1180d3dbfdaa"
  },

  colors : [
   "blue",
   "indigo",
   "purple",
   "pink",
   "red",
   "orange",
   "yellow",
   "green",
   "teal",
   "cyan",
   "white",
   "gray",
   "gray-dark",
   "primary",
   "secondary",
   "success",
   "info",
   "warning",
   "danger",
   "light",
   "dark",
  ],

  attachmentTypes : [
    {
      value: 0,
      label:  "attachmentType.noSelect",
    },
    {
      value: 1,
      label: "attachmentType.banner",
    },
    {
      value: 2,
      label: "attachmentType.conditionsOfParticipation",
    },
    {
      value: 3,
      label: "attachmentType.committees",
    },
    {
      value: 4,
      label: "attachmentType.schedule",
    },
    {
      value: 5,
      label: "attachmentType.calendar",
    },
    {
      value: 6,
      label: "attachmentType.photos",
    },
    {
      value: 7,
      label: "attachmentType.photos",
    },
    {
      value: 8,
      label: "attachmentType.photos",
    },
    {
      value: 9,
      label: "attachmentType.reportOfResult",
    },
  ],


   activityTypes : [
  
    {
      value: -1,
      label:  "activityTypes.noSelect",
    },
    {
      value: 1,
      label: "activityTypes.symposium",
    },
    {
      value: 2,
      label: "activityTypes.congress",
    },
    {
      value: 3,
      label: "activityTypes.convention",
    },
    {
      value: 4,
      label: "activityTypes.workshop",
    },
    {
      value: 5,
      label: "activityTypes.other",
    },
  ],
  arrangementTypes : [

    {
      value: -1,
      label:  "arrangementTypes.noSelect",
    },
    {
      value: 1,
      label: "arrangementTypes.institution",
    },
    {
      value: 2,
      label: "arrangementTypes.cooperation",
    },
    {
      value: 3,
      label: "arrangementTypes.support",
    },
    
  ],
  secretariats : [
    {
      value: -1,
      label:  "secretariat.noSelect",
    },
    {
      value: 1,
      label: "secretariat.institution",
    },
    {
      value: 2,
      label: "secretariat.partner",
    },
  ],
  submissionReviewDecisions : [
   
    {
      value: 0,
      label:   "submissionReview.decision.notOpened",

    },
    {
      value:1,
      label:   "submissionReview.decision.acceptReview",
  },
    {
      value: 2,
      label:   "submissionReview.decision.refereeRejected",

    },
    {
      value: 3,
      label:   "submissionReview.decision.confirmation",

    },
    {
      value: 4,
      label:   "submissionReview.decision.correction",

    },
    {
      value: 5,
      label:   "submissionReview.decision.rejection",

    },
  ],

  committeeTypes : [
    {
      value: -1,
      label:  "committeeType.noSelect",
    },
    {
      value: 1,
      label: "committeeType.honor",
    },
    {
      value: 2,
      label: "committeeType.advisory",
    },
    {
      value: 3,
      label: "committeeType.science",
    },
    {
      value: 4,
      label: "committeeType.organizing",
    },
    {
      value: 5,
      label: "committeeType.organizing",
    },
  ],

  institutions:[
    {
      value: "AKMB",
      label: "institution.akmb",
    },
    {
      value: "ATAM",
      label: "institution.atam",
    },
    {
      value: "TDK",
      label: "institution.tdk",
    },
    {
      value: "TTK",
      label: "institution.ttk",
    },
  ],

  titleList: [
    "Dr Öğretim Üyesi",
    "Prof.Dr.",
    "Doç.Dr.",
    "Öğretim Görevlisi",
    "Araştırma Görevlisi",
    "Dr.",
    "Öğretmen",
    "Diğer"
  ],
  mounth: [
    "Ocak",
    "Şubat",
    "Mart",
    "Nisan",
    "Mayıs",
    "Haziran",
    "Temmuz",
    "Ağustos",
    "Eylül",
    "Ekim",
    "Kasım",
    "Aralık"
  ],
  citys: [
    "",
    "Adana",
    "Adıyaman",
    "Afyon",
    "Ağrı",
    "Amasya",
    "Ankara",
    "Antalya",
    "Artvin",
    "Aydın",
    "Balıkesir",
    "Bilecik",
    "Bingöl",
    "Bitlis",
    "Bolu",
    "Burdur",
    "Bursa",
    "Çanakkale",
    "Çankırı",
    "Çorum",
    "Denizli",
    "Diyarbakır",
    "Edirne",
    "Elazığ",
    "Erzincan",
    "Erzurum",
    "Eskişehir",
    "Gaziantep",
    "Giresun",
    "Gümüşhane",
    "Hakkari",
    "Hatay",
    "Isparta",
    "Mersin",
    "İstanbul",
    "İzmir",
    "Kars",
    "Kastamonu",
    "Kayseri",
    "Kırklareli",
    "Kırşehir",
    "Kocaeli",
    "Konya",
    "Kütahya",
    "Malatya",
    "Manisa",
    "Kahramanmaraş",
    "Mardin",
    "Muğla",
    "Muş",
    "Nevşehir",
    "Niğde",
    "Ordu",
    "Rize",
    "Sakarya",
    "Samsun",
    "Siirt",
    "Sinop",
    "Sivas",
    "Tekirdağ",
    "Tokat",
    "Trabzon",
    "Tunceli",
    "Şanlıurfa",
    "Uşak",
    "Van",
    "Yozgat",
    "Zonguldak",
    "Aksaray",
    "Bayburt",
    "Karaman",
    "Kırıkkale",
    "Batman",
    "Şırnak",
    "Bartın",
    "Ardahan",
    "Iğdır",
    "Yalova",
    "Karabük",
    "Kilis",
    "Osmaniye",
    "Düzce"
  ],

  educationLevels: [
    "",
    "Okur-Yazar Değil",
    "Okur-Yazar",
    "İlkokul",
    "Ortaokul",
    "Lise",
    "Lisans",
    "YüksekLisans",
    "Doktora"
  ],

  fileAcceptExtension: [
    "video/x-flv",
    "video/mp4",
    "application/x-mpegURL",
    "video/MP2T",
    "video/3gpp",
    "video/quicktime",
    "video/x-msvideo",
    "video/x-ms-wmv",
    "audio/basic",
    "audio/mid",
    "audio/mpeg	RFC 3003",
    "audio	audio/mp4",
    "audio/x-mpegurl",
    "Vorbis	audio/ogg	RFC 5334",
    "audio/vnd.wav",
    "image/cgm",
    "image/fits",
    "image/g3fax",
    "image/gif",
    "image/ief",
    "image/jp2",
    "image/jpeg",
    "image/jpm",
    "image/jpx",
    "image/naplps",
    "image/png",
    "image/prs.btif",
    "image/prs.pti",
    "image/t38",
    "image/tiff",
    "image/tiff-fx",
    "image/vnd.adobe.photoshop",
    "image/vnd.cns.inf2",
    "image/vnd.djvu",
    "image/vnd.dwg",
    "image/vnd.dxf",
    "image/vnd.fastbidsheet",
    "image/vnd.fpx",
    "image/vnd.fst",
    "image/vnd.fujixerox.edmics-mmr",
    "image/vnd.fujixerox.edmics-rlc",
    "image/vnd.globalgraphics.pgb",
    "image/vnd.microsoft.icon",
    "image/vnd.mix",
    "image/vnd.ms-modi",
    "image/vnd.net-fpx",
    "image/vnd.sealed.png",
    "image/vnd.sealedmedia.softseal.gif",
    "image/vnd.sealedmedia.softseal.jpg",
    "image/vnd.svf",
    "image/vnd.wap.wbmp",
    "image/vnd.xiff",
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "application/vnd.ms-powerpoint",
    "application/vnd.openxmlformats-officedocument.presentationml.presentation",
    "application/pdf"
  ]
,

  countries:[ 
    {name: 'Afghanistan', code: 'AF'}, 
    {name: 'Åland Islands', code: 'AX'}, 
    {name: 'Albania', code: 'AL'}, 
    {name: 'Algeria', code: 'DZ'}, 
    {name: 'American Samoa', code: 'AS'}, 
    {name: 'AndorrA', code: 'AD'}, 
    {name: 'Angola', code: 'AO'}, 
    {name: 'Anguilla', code: 'AI'}, 
    {name: 'Antarctica', code: 'AQ'}, 
    {name: 'Antigua and Barbuda', code: 'AG'}, 
    {name: 'Argentina', code: 'AR'}, 
    {name: 'Armenia', code: 'AM'}, 
    {name: 'Aruba', code: 'AW'}, 
    {name: 'Australia', code: 'AU'}, 
    {name: 'Austria', code: 'AT'}, 
    {name: 'Azerbaijan', code: 'AZ'}, 
    {name: 'Bahamas', code: 'BS'}, 
    {name: 'Bahrain', code: 'BH'}, 
    {name: 'Bangladesh', code: 'BD'}, 
    {name: 'Barbados', code: 'BB'}, 
    {name: 'Belarus', code: 'BY'}, 
    {name: 'Belgium', code: 'BE'}, 
    {name: 'Belize', code: 'BZ'}, 
    {name: 'Benin', code: 'BJ'}, 
    {name: 'Bermuda', code: 'BM'}, 
    {name: 'Bhutan', code: 'BT'}, 
    {name: 'Bolivia', code: 'BO'}, 
    {name: 'Bosnia and Herzegovina', code: 'BA'}, 
    {name: 'Botswana', code: 'BW'}, 
    {name: 'Bouvet Island', code: 'BV'}, 
    {name: 'Brazil', code: 'BR'}, 
    {name: 'British Indian Ocean Territory', code: 'IO'}, 
    {name: 'Brunei Darussalam', code: 'BN'}, 
    {name: 'Bulgaria', code: 'BG'}, 
    {name: 'Burkina Faso', code: 'BF'}, 
    {name: 'Burundi', code: 'BI'}, 
    {name: 'Cambodia', code: 'KH'}, 
    {name: 'Cameroon', code: 'CM'}, 
    {name: 'Canada', code: 'CA'}, 
    {name: 'Cape Verde', code: 'CV'}, 
    {name: 'Cayman Islands', code: 'KY'}, 
    {name: 'Central African Republic', code: 'CF'}, 
    {name: 'Chad', code: 'TD'}, 
    {name: 'Chile', code: 'CL'}, 
    {name: 'China', code: 'CN'}, 
    {name: 'Christmas Island', code: 'CX'}, 
    {name: 'Cocos (Keeling) Islands', code: 'CC'}, 
    {name: 'Colombia', code: 'CO'}, 
    {name: 'Comoros', code: 'KM'}, 
    {name: 'Congo', code: 'CG'}, 
    {name: 'Congo, The Democratic Republic of the', code: 'CD'}, 
    {name: 'Cook Islands', code: 'CK'}, 
    {name: 'Costa Rica', code: 'CR'}, 
    {name: 'Cote D\'Ivoire', code: 'CI'}, 
    {name: 'Croatia', code: 'HR'}, 
    {name: 'Cuba', code: 'CU'}, 
    {name: 'Cyprus', code: 'CY'}, 
    {name: 'Czech Republic', code: 'CZ'}, 
    {name: 'Denmark', code: 'DK'}, 
    {name: 'Djibouti', code: 'DJ'}, 
    {name: 'Dominica', code: 'DM'}, 
    {name: 'Dominican Republic', code: 'DO'}, 
    {name: 'Ecuador', code: 'EC'}, 
    {name: 'Egypt', code: 'EG'}, 
    {name: 'El Salvador', code: 'SV'}, 
    {name: 'Equatorial Guinea', code: 'GQ'}, 
    {name: 'Eritrea', code: 'ER'}, 
    {name: 'Estonia', code: 'EE'}, 
    {name: 'Ethiopia', code: 'ET'}, 
    {name: 'Falkland Islands (Malvinas)', code: 'FK'}, 
    {name: 'Faroe Islands', code: 'FO'}, 
    {name: 'Fiji', code: 'FJ'}, 
    {name: 'Finland', code: 'FI'}, 
    {name: 'France', code: 'FR'}, 
    {name: 'French Guiana', code: 'GF'}, 
    {name: 'French Polynesia', code: 'PF'}, 
    {name: 'French Southern Territories', code: 'TF'}, 
    {name: 'Gabon', code: 'GA'}, 
    {name: 'Gambia', code: 'GM'}, 
    {name: 'Georgia', code: 'GE'}, 
    {name: 'Germany', code: 'DE'}, 
    {name: 'Ghana', code: 'GH'}, 
    {name: 'Gibraltar', code: 'GI'}, 
    {name: 'Greece', code: 'GR'}, 
    {name: 'Greenland', code: 'GL'}, 
    {name: 'Grenada', code: 'GD'}, 
    {name: 'Guadeloupe', code: 'GP'}, 
    {name: 'Guam', code: 'GU'}, 
    {name: 'Guatemala', code: 'GT'}, 
    {name: 'Guernsey', code: 'GG'}, 
    {name: 'Guinea', code: 'GN'}, 
    {name: 'Guinea-Bissau', code: 'GW'}, 
    {name: 'Guyana', code: 'GY'}, 
    {name: 'Haiti', code: 'HT'}, 
    {name: 'Heard Island and Mcdonald Islands', code: 'HM'}, 
    {name: 'Holy See (Vatican City State)', code: 'VA'}, 
    {name: 'Honduras', code: 'HN'}, 
    {name: 'Hong Kong', code: 'HK'}, 
    {name: 'Hungary', code: 'HU'}, 
    {name: 'Iceland', code: 'IS'}, 
    {name: 'India', code: 'IN'}, 
    {name: 'Indonesia', code: 'ID'}, 
    {name: 'Iran, Islamic Republic Of', code: 'IR'}, 
    {name: 'Iraq', code: 'IQ'}, 
    {name: 'Ireland', code: 'IE'}, 
    {name: 'Isle of Man', code: 'IM'}, 
    {name: 'Israel', code: 'IL'}, 
    {name: 'Italy', code: 'IT'}, 
    {name: 'Jamaica', code: 'JM'}, 
    {name: 'Japan', code: 'JP'}, 
    {name: 'Jersey', code: 'JE'}, 
    {name: 'Jordan', code: 'JO'}, 
    {name: 'Kazakhstan', code: 'KZ'}, 
    {name: 'Kenya', code: 'KE'}, 
    {name: 'Kiribati', code: 'KI'}, 
    {name: 'Korea, Democratic People\'S Republic of', code: 'KP'}, 
    {name: 'Korea, Republic of', code: 'KR'}, 
    {name: 'Kuwait', code: 'KW'}, 
    {name: 'Kyrgyzstan', code: 'KG'}, 
    {name: 'Lao People\'S Democratic Republic', code: 'LA'}, 
    {name: 'Latvia', code: 'LV'}, 
    {name: 'Lebanon', code: 'LB'}, 
    {name: 'Lesotho', code: 'LS'}, 
    {name: 'Liberia', code: 'LR'}, 
    {name: 'Libyan Arab Jamahiriya', code: 'LY'}, 
    {name: 'Liechtenstein', code: 'LI'}, 
    {name: 'Lithuania', code: 'LT'}, 
    {name: 'Luxembourg', code: 'LU'}, 
    {name: 'Macao', code: 'MO'}, 
    {name: 'Macedonia, The Former Yugoslav Republic of', code: 'MK'}, 
    {name: 'Madagascar', code: 'MG'}, 
    {name: 'Malawi', code: 'MW'}, 
    {name: 'Malaysia', code: 'MY'}, 
    {name: 'Maldives', code: 'MV'}, 
    {name: 'Mali', code: 'ML'}, 
    {name: 'Malta', code: 'MT'}, 
    {name: 'Marshall Islands', code: 'MH'}, 
    {name: 'Martinique', code: 'MQ'}, 
    {name: 'Mauritania', code: 'MR'}, 
    {name: 'Mauritius', code: 'MU'}, 
    {name: 'Mayotte', code: 'YT'}, 
    {name: 'Mexico', code: 'MX'}, 
    {name: 'Micronesia, Federated States of', code: 'FM'}, 
    {name: 'Moldova, Republic of', code: 'MD'}, 
    {name: 'Monaco', code: 'MC'}, 
    {name: 'Mongolia', code: 'MN'}, 
    {name:  "mm", code: 'MS'}, 
    {name: 'Morocco', code: 'MA'}, 
    {name: 'Mozambique', code: 'MZ'}, 
    {name: 'Myanmar', code: 'MM'}, 
    {name: 'Namibia', code: 'NA'}, 
    {name: 'Nauru', code: 'NR'}, 
    {name: 'Nepal', code: 'NP'}, 
    {name: 'Netherlands', code: 'NL'}, 
    {name: 'Netherlands Antilles', code: 'AN'}, 
    {name: 'New Caledonia', code: 'NC'}, 
    {name: 'New Zealand', code: 'NZ'}, 
    {name: 'Nicaragua', code: 'NI'}, 
    {name: 'Niger', code: 'NE'}, 
    {name: 'Nigeria', code: 'NG'}, 
    {name: 'Niue', code: 'NU'}, 
    {name: 'Norfolk Island', code: 'NF'}, 
    {name: 'Northern Mariana Islands', code: 'MP'}, 
    {name: 'Norway', code: 'NO'}, 
    {name: 'Oman', code: 'OM'}, 
    {name: 'Pakistan', code: 'PK'}, 
    {name: 'Palau', code: 'PW'}, 
    {name: 'Palestinian Territory, Occupied', code: 'PS'}, 
    {name: 'Panama', code: 'PA'}, 
    {name: 'Papua New Guinea', code: 'PG'}, 
    {name: 'Paraguay', code: 'PY'}, 
    {name: 'Peru', code: 'PE'}, 
    {name: 'Philippines', code: 'PH'}, 
    {name: 'Pitcairn', code: 'PN'}, 
    {name: 'Poland', code: 'PL'}, 
    {name: 'Portugal', code: 'PT'}, 
    {name: 'Puerto Rico', code: 'PR'}, 
    {name: 'Qatar', code: 'QA'}, 
    {name: 'Reunion', code: 'RE'}, 
    {name: 'Romania', code: 'RO'}, 
    {name: 'Russian Federation', code: 'RU'}, 
    {name: 'RWANDA', code: 'RW'}, 
    {name: 'Saint Helena', code: 'SH'}, 
    {name: 'Saint Kitts and Nevis', code: 'KN'}, 
    {name: 'Saint Lucia', code: 'LC'}, 
    {name: 'Saint Pierre and Miquelon', code: 'PM'}, 
    {name: 'Saint Vincent and the Grenadines', code: 'VC'}, 
    {name: 'Samoa', code: 'WS'}, 
    {name: 'San Marino', code: 'SM'}, 
    {name: 'Sao Tome and Principe', code: 'ST'}, 
    {name: 'Saudi Arabia', code: 'SA'}, 
    {name: 'Senegal', code: 'SN'}, 
    {name: 'Serbia and Montenegro', code: 'CS'}, 
    {name: 'Seychelles', code: 'SC'}, 
    {name: 'Sierra Leone', code: 'SL'}, 
    {name: 'Singapore', code: 'SG'}, 
    {name: 'Slovakia', code: 'SK'}, 
    {name: 'Slovenia', code: 'SI'}, 
    {name: 'Solomon Islands', code: 'SB'}, 
    {name: 'Somalia', code: 'SO'}, 
    {name: 'South Africa', code: 'ZA'}, 
    {name: 'South Georgia and the South Sandwich Islands', code: 'GS'}, 
    {name: 'Spain', code: 'ES'}, 
    {name: 'Sri Lanka', code: 'LK'}, 
    {name: 'Sudan', code: 'SD'}, 
    {name: 'Suriname', code: 'SR'}, 
    {name: 'Svalbard and Jan Mayen', code: 'SJ'}, 
    {name: 'Swaziland', code: 'SZ'}, 
    {name: 'Sweden', code: 'SE'}, 
    {name: 'Switzerland', code: 'CH'}, 
    {name: 'Syrian Arab Republic', code: 'SY'}, 
    {name: 'Taiwan, Province of China', code: 'TW'}, 
    {name: 'Tajikistan', code: 'TJ'}, 
    {name: 'Tanzania, United Republic of', code: 'TZ'}, 
    {name: 'Thailand', code: 'TH'}, 
    {name: 'Timor-Leste', code: 'TL'}, 
    {name: 'Togo', code: 'TG'}, 
    {name: 'Tokelau', code: 'TK'}, 
    {name: 'Tonga', code: 'TO'}, 
    {name: 'Trinidad and Tobago', code: 'TT'}, 
    {name: 'Tunisia', code: 'TN'}, 
    {name: 'Turkey', code: 'TR'}, 
    {name: 'Turkmenistan', code: 'TM'}, 
    {name: 'Turks and Caicos Islands', code: 'TC'}, 
    {name: 'Tuvalu', code: 'TV'}, 
    {name: 'Uganda', code: 'UG'}, 
    {name: 'Ukraine', code: 'UA'}, 
    {name: 'United Arab Emirates', code: 'AE'}, 
    {name: 'United Kingdom', code: 'GB'}, 
    {name: 'United States', code: 'US'}, 
    {name: 'United States Minor Outlying Islands', code: 'UM'}, 
    {name: 'Uruguay', code: 'UY'}, 
    {name: 'Uzbekistan', code: 'UZ'}, 
    {name: 'Vanuatu', code: 'VU'}, 
    {name: 'Venezuela', code: 'VE'}, 
    {name: 'Viet Nam', code: 'VN'}, 
    {name: 'Virgin Islands, British', code: 'VG'}, 
    {name: 'Virgin Islands, U.S.', code: 'VI'}, 
    {name: 'Wallis and Futuna', code: 'WF'}, 
    {name: 'Western Sahara', code: 'EH'}, 
    {name: 'Yemen', code: 'YE'}, 
    {name: 'Zambia', code: 'ZM'}, 
    {name: 'Zimbabwe', code: 'ZW'} 
  ],
  countriesTR : [
    { value: 'TR', label: 'Türkiye' },
    { value: 'VI', label: 'ABD Virgin Adaları' },
    { value: 'AF', label: 'Afganistan' },
    { value: 'AX', label: 'Aland Adaları' },
    { value: 'DE', label: 'Almanya' },
    { value: 'US', label: 'Amerika Birleşik Devletleri' },
    { value: 'UM', label: 'Amerika Birleşik Devletleri Küçük Dış Adaları' },
    { value: 'AS', label: 'Amerikan Samoası' },
    { value: 'AD', label: 'Andora' },
    { value: 'AO', label: 'Angola' },
    { value: 'AI', label: 'Anguilla' },
    { value: 'AQ', label: 'Antarktika' },
    { value: 'AG', label: 'Antigua ve Barbuda' },
    { value: 'AR', label: 'Arjantin' },
    { value: 'AL', label: 'Arnavutluk' },
    { value: 'AW', label: 'Aruba' },
    { value: 'QU', label: 'Avrupa Birliği' },
    { value: 'AU', label: 'Avustralya' },
    { value: 'AT', label: 'Avusturya' },
    { value: 'AZ', label: 'Azerbaycan' },
    { value: 'BS', label: 'Bahamalar' },
    { value: 'BH', label: 'Bahreyn' },
    { value: 'BD', label: 'Bangladeş' },
    { value: 'BB', label: 'Barbados' },
    { value: 'EH', label: 'Batı Sahara' },
    { value: 'BZ', label: 'Belize' },
    { value: 'BE', label: 'Belçika' },
    { value: 'BJ', label: 'Benin' },
    { value: 'BM', label: 'Bermuda' },
    { value: 'BY', label: 'Beyaz Rusya' },
    { value: 'BT', label: 'Bhutan' },
    { value: 'ZZ', label: 'Bilinmeyen veya Geçersiz Bölge' },
    { value: 'AE', label: 'Birleşik Arap Emirlikleri' },
    { value: 'GB', label: 'Birleşik Krallık' },
    { value: 'BO', label: 'Bolivya' },
    { value: 'BA', label: 'Bosna Hersek' },
    { value: 'BW', label: 'Botsvana' },
    { value: 'BV', label: 'Bouvet Adası' },
    { value: 'BR', label: 'Brezilya' },
    { value: 'BN', label: 'Brunei' },
    { value: 'BG', label: 'Bulgaristan' },
    { value: 'BF', label: 'Burkina Faso' },
    { value: 'BI', label: 'Burundi' },
    { value: 'CV', label: 'Cape Verde' },
    { value: 'GI', label: 'Cebelitarık' },
    { value: 'DZ', label: 'Cezayir' },
    { value: 'CX', label: 'Christmas Adası' },
    { value: 'DJ', label: 'Cibuti' },
    { value: 'CC', label: 'Cocos Adaları' },
    { value: 'CK', label: 'Cook Adaları' },
    { value: 'TD', label: 'Çad' },
    { value: 'CZ', label: 'Çek Cumhuriyeti' },
    { value: 'CN', label: 'Çin' },
    { value: 'DK', label: 'Danimarka' },
    { value: 'DM', label: 'Dominik' },
    { value: 'DO', label: 'Dominik Cumhuriyeti' },
    { value: 'TL', label: 'Doğu Timor' },
    { value: 'EC', label: 'Ekvator' },
    { value: 'GQ', label: 'Ekvator Ginesi' },
    { value: 'SV', label: 'El Salvador' },
    { value: 'ID', label: 'Endonezya' },
    { value: 'ER', label: 'Eritre' },
    { value: 'AM', label: 'Ermenistan' },
    { value: 'EE', label: 'Estonya' },
    { value: 'ET', label: 'Etiyopya' },
    { value: 'FK', label: 'Falkland Adaları (Malvinalar)' },
    { value: 'FO', label: 'Faroe Adaları' },
    { value: 'MA', label: 'Fas' },
    { value: 'FJ', label: 'Fiji' },
    { value: 'CI', label: 'Fildişi Sahilleri' },
    { value: 'PH', label: 'Filipinler' },
    { value: 'PS', label: 'Filistin Bölgesi' },
    { value: 'FI', label: 'Finlandiya' },
    { value: 'FR', label: 'Fransa' },
    { value: 'GF', label: 'Fransız Guyanası' },
    { value: 'TF', label: 'Fransız Güney Bölgeleri' },
    { value: 'PF', label: 'Fransız Polinezyası' },
    { value: 'GA', label: 'Gabon' },
    { value: 'GM', label: 'Gambia' },
    { value: 'GH', label: 'Gana' },
    { value: 'GN', label: 'Gine' },
    { value: 'GW', label: 'Gine-Bissau' },
    { value: 'GD', label: 'Granada' },
    { value: 'GL', label: 'Grönland' },
    { value: 'GP', label: 'Guadeloupe' },
    { value: 'GU', label: 'Guam' },
    { value: 'GT', label: 'Guatemala' },
    { value: 'GG', label: 'Guernsey' },
    { value: 'GY', label: 'Guyana' },
    { value: 'ZA', label: 'Güney Afrika' },
    { value: 'GS', label: 'Güney Georgia ve Güney Sandwich Adaları' },
    { value: 'KR', label: 'Güney Kore' },
    { value: 'CY', label: 'Güney Kıbrıs Rum Kesimi' },
    { value: 'GE', label: 'Gürcistan' },
    { value: 'HT', label: 'Haiti' },
    { value: 'HM', label: 'Heard Adası ve McDonald Adaları' },
    { value: 'IN', label: 'Hindistan' },
    { value: 'IO', label: 'Hint Okyanusu İngiliz Bölgesi' },
    { value: 'NL', label: 'Hollanda' },
    { value: 'AN', label: 'Hollanda Antilleri' },
    { value: 'HN', label: 'Honduras' },
    { value: 'HK', label: 'Hong Kong SAR - Çin' },
    { value: 'HR', label: 'Hırvatistan' },
    { value: 'IQ', label: 'Irak' },
    { value: 'VG', label: 'İngiliz Virgin Adaları' },
    { value: 'IR', label: 'İran' },
    { value: 'IE', label: 'İrlanda' },
    { value: 'ES', label: 'İspanya' },
    { value: 'IL', label: 'İsrail' },
    { value: 'SE', label: 'İsveç' },
    { value: 'CH', label: 'İsviçre' },
    { value: 'IT', label: 'İtalya' },
    { value: 'IS', label: 'İzlanda' },
    { value: 'JM', label: 'Jamaika' },
    { value: 'JP', label: 'Japonya' },
    { value: 'JE', label: 'Jersey' },
    { value: 'KH', label: 'Kamboçya' },
    { value: 'CM', label: 'Kamerun' },
    { value: 'CA', label: 'Kanada' },
    { value: 'ME', label: 'Karadağ' },
    { value: 'QA', label: 'Katar' },
    { value: 'KY', label: 'Kayman Adaları' },
    { value: 'KZ', label: 'Kazakistan' },
    { value: 'KE', label: 'Kenya' },
    { value: 'KI', label: 'Kiribati' },
    { value: 'CO', label: 'Kolombiya' },
    { value: 'KM', label: 'Komorlar' },
    { value: 'CG', label: 'Kongo' },
    { value: 'CD', label: 'Kongo Demokratik Cumhuriyeti' },
    { value: 'CR', label: 'Kosta Rika' },
    { value: 'KW', label: 'Kuveyt' },
    { value: 'KP', label: 'Kuzey Kore' },
    { value: 'MP', label: 'Kuzey Mariana Adaları' },
    { value: 'CU', label: 'Küba' },
    { value: 'KG', label: 'Kırgızistan' },
    { value: 'LA', label: 'Laos' },
    { value: 'LS', label: 'Lesotho' },
    { value: 'LV', label: 'Letonya' },
    { value: 'LR', label: 'Liberya' },
    { value: 'LY', label: 'Libya' },
    { value: 'LI', label: 'Liechtenstein' },
    { value: 'LT', label: 'Litvanya' },
    { value: 'LB', label: 'Lübnan' },
    { value: 'LU', label: 'Lüksemburg' },
    { value: 'HU', label: 'Macaristan' },
    { value: 'MG', label: 'Madagaskar' },
    { value: 'MO', label: 'Makao S.A.R. Çin' },
    { value: 'MK', label: 'Makedonya' },
    { value: 'MW', label: 'Malavi' },
    { value: 'MV', label: 'Maldivler' },
    { value: 'MY', label: 'Malezya' },
    { value: 'ML', label: 'Mali' },
    { value: 'MT', label: 'Malta' },
    { value: 'IM', label: 'Man Adası' },
    { value: 'MH', label: 'Marshall Adaları' },
    { value: 'MQ', label: 'Martinik' },
    { value: 'MU', label: 'Mauritius' },
    { value: 'YT', label: 'Mayotte' },
    { value: 'MX', label: 'Meksika' },
    { value: 'FM', label: 'Mikronezya Federal Eyaletleri' },
    { value: 'MD', label: 'Moldovya Cumhuriyeti' },
    { value: 'MC', label: 'Monako' },
    { value: 'MS', label: 'Montserrat' },
    { value: 'MR', label: 'Moritanya' },
    { value: 'MZ', label: 'Mozambik' },
    { value: 'MN', label: 'Moğolistan' },
    { value: 'MM', label: 'Myanmar' },
    { value: 'EG', label: 'Mısır' },
    { value: 'NA', label: 'Namibya' },
    { value: 'NR', label: 'Nauru' },
    { value: 'NP', label: 'Nepal' },
    { value: 'NE', label: 'Nijer' },
    { value: 'NG', label: 'Nijerya' },
    { value: 'NI', label: 'Nikaragua' },
    { value: 'NU', label: 'Niue' },
    { value: 'NF', label: 'Norfolk Adası' },
    { value: 'NO', label: 'Norveç' },
    { value: 'CF', label: 'Orta Afrika Cumhuriyeti' },
    { value: 'UZ', label: 'Özbekistan' },
    { value: 'PK', label: 'Pakistan' },
    { value: 'PW', label: 'Palau' },
    { value: 'PA', label: 'Panama' },
    { value: 'PG', label: 'Papua Yeni Gine' },
    { value: 'PY', label: 'Paraguay' },
    { value: 'PE', label: 'Peru' },
    { value: 'PN', label: 'Pitcairn' },
    { value: 'PL', label: 'Polonya' },
    { value: 'PT', label: 'Portekiz' },
    { value: 'PR', label: 'Porto Riko' },
    { value: 'RE', label: 'Reunion' },
    { value: 'RO', label: 'Romanya' },
    { value: 'RW', label: 'Ruanda' },
    { value: 'RU', label: 'Rusya Federasyonu' },
    { value: 'SH', label: 'Saint Helena' },
    { value: 'KN', label: 'Saint Kitts ve Nevis' },
    { value: 'LC', label: 'Saint Lucia' },
    { value: 'PM', label: 'Saint Pierre ve Miquelon' },
    { value: 'VC', label: 'Saint Vincent ve Grenadinler' },
    { value: 'WS', label: 'Samoa' },
    { value: 'SM', label: 'San Marino' },
    { value: 'ST', label: 'Sao Tome ve Principe' },
    { value: 'SN', label: 'Senegal' },
    { value: 'SC', label: 'Seyşeller' },
    { value: 'SL', label: 'Sierra Leone' },
    { value: 'SG', label: 'Singapur' },
    { value: 'SK', label: 'Slovakya' },
    { value: 'SI', label: 'Slovenya' },
    { value: 'SB', label: 'Solomon Adaları' },
    { value: 'SO', label: 'Somali' },
    { value: 'LK', label: 'Sri Lanka' },
    { value: 'SD', label: 'Sudan' },
    { value: 'SR', label: 'Surinam' },
    { value: 'SY', label: 'Suriye' },
    { value: 'SA', label: 'Suudi Arabistan' },
    { value: 'SJ', label: 'Svalbard ve Jan Mayen' },
    { value: 'SZ', label: 'Svaziland' },
    { value: 'RS', label: 'Sırbistan' },
    { value: 'CS', label: 'Sırbistan-Karadağ' },
    { value: 'CL', label: 'Şili' },
    { value: 'TJ', label: 'Tacikistan' },
    { value: 'TZ', label: 'Tanzanya' },
    { value: 'TH', label: 'Tayland' },
    { value: 'TW', label: 'Tayvan' },
    { value: 'TG', label: 'Togo' },
    { value: 'TK', label: 'Tokelau' },
    { value: 'TO', label: 'Tonga' },
    { value: 'TT', label: 'Trinidad ve Tobago' },
    { value: 'TN', label: 'Tunus' },
    { value: 'TC', label: 'Turks ve Caicos Adaları' },
    { value: 'TV', label: 'Tuvalu' },
    { value: 'TM', label: 'Türkmenistan' },
    { value: 'UG', label: 'Uganda' },
    { value: 'UA', label: 'Ukrayna' },
    { value: 'OM', label: 'Umman' },
    { value: 'UY', label: 'Uruguay' },
    { value: 'QO', label: 'Uzak Okyanusya' },
    { value: 'JO', label: 'Ürdün' },
    { value: 'VU', label: 'Vanuatu' },
    { value: 'VA', label: 'Vatikan' },
    { value: 'VE', label: 'Venezuela' },
    { value: 'VN', label: 'Vietnam' },
    { value: 'WF', label: 'Wallis ve Futuna' },
    { value: 'YE', label: 'Yemen' },
    { value: 'NC', label: 'Yeni Kaledonya' },
    { value: 'NZ', label: 'Yeni Zelanda' },
    { value: 'GR', label: 'Yunanistan' },
    { value: 'ZM', label: 'Zambiya' },
    { value: 'ZW', label: 'Zimbabve' },
    ],

    languagesTR : [{value:"Türkçe"},{value:"İngilizce"},{value:"Almanca"},{value:"Arapça"},{value:"Azerice"},{value:"Kürtçe"},{value:"Çince (Basitleştirilmiş)"},{value:"Çince (Geleneksel)"},{value:"Fransızca"},{value:"Rusça"},{value:"Farsça"},{value:"Filipince"},{value:"İspanyolca"},{value:"İsveççe"},{value:"İtalyanca"},{value:"Japonca"},{value:"Afrikaanca"},{value:"Amharca"},{value:"Arnavutça"},{value:"Baskça"},{value:"Batı Frizcesi"},{value:"Belarusça"},{value:"Bengalce"},{value:"Boşnakça"},{value:"Bulgarca"},{value:"Burmaca"},{value:"Cava Dili"},{value:"Cebuano"},{value:"Çekçe"},{value:"Danca"},{value:"Endonezce"},{value:"Ermenice"},{value:"Esperanto"},{value:"Estonca"},{value:"Felemenkçe"},{value:"Fince"},{value:"Galce"},{value:"Galiçyaca"},{value:"Güceratça"},{value:"Güney Sotho dili"},{value:"Gürcüce"},{value:"Hausa dili"},{value:"Haiti Kreyolu"},{value:"Hawaii dili"},{value:"Hırvatça"},{value:"Hintçe"},{value:"Hmong Dili"},{value:"İbo dili"},{value:"İbranice"},{value:"İrlandaca"},{value:"İskoç Gaelcesi"},{value:"İzlandaca"},{value:"Kannada dili"},{value:"Katalanca"},{value:"Kazakça"},{value:"Kırgızca"},{value:"Kmerce"},{value:"Korece"},{value:"Korsikaca"},{value:"Lao dili"},{value:"Latince"},{value:"Lehçe"},{value:"Letonca"},{value:"Litvanca"},{value:"Lüksemburgca"},{value:"Makedonca"},{value:"Macarca"},{value:"Malayalam dili"},{value:"Malayca"},{value:"Malgaşça"},{value:"Maltaca"},{value:"Maori dili"},{value:"Marathi"},{value:"Moğolca"},{value:"Nepalce"},{value:"Norveççe"},{value:"Nyanja"},{value:"Özbekçe"},{value:"Pencapça"},{value:"Peştuca"},{value:"Portekizce"},{value:"Rumence"},{value:"Samoa dili"},{value:"Seylanca"},{value:"Shona"},{value:"Sırpça"},{value:"Sindhi"},{value:"Slovakça"},{value:"Slovence"},{value:"Somalice"},{value:"Sunda Dili"},{value:"Svahili"},{value:"Tacikçe"},{value:"Tamilce"},{value:"Tayca"},{value:"Telugu dili"},{value:"Ukraynaca"},{value:"Urduca"},{value:"Vietnamca"},{value:"Yidiş"},{value:"Yorubaca"},{value:"Yunanca"},{value:"Zosa dili"},{value:"Zuluca"}],


};
